import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { LiquidationAttributes } from '../../interfaces/liquidation.interface';

/**
 * Liquidation User Cell Renderer
 *
 * Displays user information:
 * - Username (bold, small font)
 * - Email (below, gray)
 */
@Component({
  selector: 'app-liquidation-user-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="truncate">
      <span class="block truncate font-bold text-[10px]">{{ username }}</span>
      <span class="block truncate text-xs text-gray-600 dark:text-gray-400">{{ email }}</span>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LiquidationUserCellRendererComponent implements CellRenderer<LiquidationAttributes> {
  @Input() params!: CellRendererParams<LiquidationAttributes>;

  get username(): string {
    return this.params?.data?.user?.user_login?.username || '-';
  }

  get email(): string {
    return this.params?.data?.user?.user_login?.email || '';
  }
}
